import { createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "@react-native-async-storage/async-storage";
// import createSensitiveStorage from "redux-persist-sensitive-storage";
import { STORAGE_KEY } from "./config";
import rootReducer from "./reducers";

// const storage = createSensitiveStorage({
//   keychainService: "myKeychainStyleOn",
//   sharedPreferencesName: STORAGE_KEY,
// });

const persistConfig = {
  key: "styleon",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

let store = createStore(persistedReducer);
let persistor = persistStore(store);
export { store, persistor };
